// extracted by mini-css-extract-plugin
module.exports = {"menuSelector":"MenuSelection_menuSelector__zMpVj","menuName":"MenuSelection_menuName__F5hY7","active":"MenuSelection_active__xxtb6","adjacent":"MenuSelection_adjacent__5Ksmo"};